import { Clock } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { AVAIL_LABEL, NO_SCHEDULE, hoursText } from "@/lib/api";

const COLORS = {
  available: "bg-nanina-freshsoft text-nanina-green",
  full: "bg-nanina-butter/60 text-nanina-green",
  temp_closed: "bg-nanina-peach/40 text-[#7A3B2E]",
  closed: "bg-gray-200 text-gray-700",
};

export const AvailBadge = ({ status, testId }) =>
  AVAIL_LABEL[status] ? (
    <span className={`text-[11px] font-semibold rounded-full px-2.5 py-1 ${COLORS[status]}`} data-testid={testId}>{AVAIL_LABEL[status]}</span>
  ) : null;

export const HoursList = ({ hours, testId }) =>
  hours?.length ? (
    <ul className="divide-y divide-nanina-line" data-testid={testId}>
      {hours.map((h, i) => (
        <li key={i} className="flex justify-between gap-3 py-1.5 text-sm">
          <span className="text-nanina-muted">{h.days}</span>
          <span className="font-semibold text-nanina-green text-right">{hoursText(h)}</span>
        </li>
      ))}
    </ul>
  ) : (
    <p className="text-xs text-nanina-muted" data-testid={`${testId}-empty`}>{NO_SCHEDULE}</p>
  );

export const ServiceSchedule = ({ categoryId }) => {
  const { site } = useSite();
  const sch = site.settings.service_schedules?.[categoryId] || {};
  const hours = sch.hours?.length ? sch.hours : site.settings.operating_hours || [];
  return (
    <div className="mt-4 rounded-2xl border border-nanina-line p-3.5" data-testid="service-schedule">
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <p className="flex items-center gap-1.5 text-xs font-bold text-nanina-green"><Clock className="h-3.5 w-3.5" /> Jadwal layanan</p>
        <AvailBadge status={sch.status} testId="service-availability-badge" />
      </div>
      {sch.notice && <p className="mb-1.5 text-xs text-[#8A6D3B]" data-testid="service-notice">{sch.notice}</p>}
      <HoursList hours={hours} testId="service-hours" />
      <p className="mt-1.5 text-[10px] text-nanina-muted">Ketersediaan slot selalu dikonfirmasi admin melalui WhatsApp.</p>
    </div>
  );
};
